// Select input fields for phone number and email
const phoneField = document.querySelector(".bis-popup-number");
const emailField = document.querySelector(".bis-popup-email");

// Define a class to globally store product and variant information
class ProductInfo {
  constructor() {
    this.productId = null;
    this.variantId = null;
  }
}
// Create a global instance to hold product information
const productInfo = new ProductInfo();

// Class to handle mutual exclusivity between two input fields
class InputFieldHandler {
  constructor(field, otherField) {
    this.field = field; // Reference to the current input field
    this.otherField = otherField; // Reference to the other input field
  }
  // Toggles the state of the other input field based on the current field's value
  toggleFieldState() {
    if (this.field.value.length > 0) {
      this.otherField.disabled = true; // Disable the other field
      this.otherField.classList.add("input-disabled"); // Add visual cue
      this.otherField.value = ''; // clear the value of the other field
    } else {
      this.otherField.disabled = false;  // Enable the other field
      this.otherField.classList.remove("input-disabled"); // Remove visual cue
    }
  }
  // Adds focus and blur event listeners to adjust the state dynamically
  handleFocusBlur() {
    this.field.addEventListener("focus", () => {
      this.otherField.disabled = true;
      this.otherField.classList.add("input-disabled-focus");// Add focus-specific visual cue
    });

    this.field.addEventListener("blur", () => {
      if (this.field.value.length === 0) {
        this.otherField.disabled = false;
        this.otherField.classList.remove("input-disabled-focus");// Remove focus-specific visual cue
      }
    });
  }
 // Initializes the input field handler by attaching relevant event listeners
  init() {
    this.field.addEventListener("input", () => this.toggleFieldState());// Listen for input changes
    this.handleFocusBlur();// Attach focus and blur listeners
  }
}

// Initialize handlers for phone and email fields to ensure they function exclusively
const phoneFieldHandler = new InputFieldHandler(phoneField, emailField);
const emailFieldHandler = new InputFieldHandler(emailField, phoneField);

phoneFieldHandler.init();
emailFieldHandler.init();

// Class for handling modal interactions and product size selection
if (!customElements.get('bis-modal')) {
  customElements.define('bis-modal', class BisModal extends ModalOpener {
    constructor() {
      super();
      this.setupSizeInputChangeListener();// Attach event listener for size selection changes
      this.successMessage = document.querySelector('.bis-popup-sucess'); // Success message element
    }
    // Attaches listener to detect changes in size inputs (e.g., radio buttons)
    setupSizeInputChangeListener() {
      const sizeInputsWrapper = document.querySelector('.size-inputs-wrapper');
      if (sizeInputsWrapper) {
        sizeInputsWrapper.addEventListener("change", (event) => {
          this.handleSizeInputChange(event);// Delegate handling to a separate method
        });
      }
    }

    // Handles the logic for updating product info when size input is selected
    handleSizeInputChange(event) {

      // Check if the clicked element is a valid radio button
      const sizeOptionName = document.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';
      
      // Instead of writing new function we're levreging data setup by GenderToggle function from global.js
      const uniSexMenWomenTabs = document.querySelector('.gender-tabs__list button.active')?.dataset.tabGender || '';

      if (event.target.type === "radio" && event.target.name === sizeOptionName && event.target.classList.contains("disabled")) {
        const selectedLocation = document.getElementById('product-size-dropdown-button')?.dataset.selectedLocation;
        const localizedSizeMen = event.target.getAttribute(`data-size-men-${selectedLocation?.toLowerCase()}`);
        const localizedSizeWomen = event.target.getAttribute(`data-size-women-${selectedLocation?.toLowerCase()}`);
        let { valueVariantId, productId, sizeWomen, sizeMen , activeGender, sizeUnisex } = event.target.dataset;

        // Set men/women size value to prefer localized size value
        sizeWomen = localizedSizeWomen ?? sizeWomen;
        sizeMen = localizedSizeMen ?? sizeMen;

        // Check if variantId is available
        if (!valueVariantId) {
          console.log("Variant ID is undefined");
          return;
        }
        // Store the selected variantId and productId globally
        productInfo.productId = productId;
        productInfo.variantId = valueVariantId;

        let productGender = "";
        // Determine product gender and size based on the current tab and data attributes
        switch (true) {
          case !!uniSexMenWomenTabs:
            // Nested switch to handle the unisex tab cases for Men/Women Products
            switch (uniSexMenWomenTabs) {
              case "men":
                productGender = `${window.genderStrings.men} / ${sizeMen}`;
                break;
              case "women":
                productGender = `${window.genderStrings.women} / ${sizeWomen}`;
                break;
              default:
                console.log("Unisex tab has an invalid value.");
                break;
            }
          break;

          case !!sizeUnisex:
            // If unisex size is present as a variant
            productGender = `${window.genderStrings.unisex} / ${sizeUnisex}`;
            console.log('sizeUnisex - Unisex');
            break;

          case activeGender === "men" && !!sizeMen:
            // Handle men's size
            productGender = `${window.genderStrings.men} / ${sizeMen}`;
            console.log('activeGender - Men');
            break;

          case activeGender === "women" && !!sizeWomen:
            // Handle women's size
            productGender = `${window.genderStrings.women} / ${sizeWomen}`;
            console.log('activeGender - WoMen');
            break;

          default:
            // Fallback in case of missing or invalid data
            console.log("Invalid gender or size data provided.");
            break;
        }
        // Update the product input field with the selected size and gender information
        const productInput = document.getElementById("bis-product-name-input");
        if (productInput) {
          productInput.value = productGender;
        } else {
          console.log("Product name input field not found.");
        }
        
      }
    }
  });
}

// Class to handle form submission for the Back-in-Stock (BIS) notification
class FormSubmissionHandler {
  constructor(sendButton, emailField, phoneField, productInfo, modal) {
    this.sendButton = sendButton;
    this.emailField = emailField;
    this.phoneField = phoneField;
    this.productInfo = productInfo;
    this.modal = modal;
    this.emailFieldParent = emailField.closest('.field');
    this.phoneFieldParent = phoneField.closest('.field');
    this.successMessage = document.querySelector('.bis-popup-sucess');
    this.subscribedMessage = document.querySelector('.bis-popup-subscribed');
  }

  formatPhoneNumber(phoneNumber) {
    // Remove spaces, hyphens, and parentheses
    let cleanNumber = phoneNumber.replace(/[\s-()]/g, '');
  
    // Check if already in a valid E.164 format
    if (/^\+\d{10,15}$/.test(cleanNumber)) {
      console.log('Formatted phone number:', cleanNumber);
      return cleanNumber;  // Valid international number
    }
  
    // Handle US-based number without country code
    if (/^1\d{10}$/.test(cleanNumber)) {
      const formattedNumber = `+${cleanNumber}`;
      // console.log('Formatted phone number:', formattedNumber);
      return formattedNumber;
    } else if (/^\d{10}$/.test(cleanNumber)) {
      const formattedNumber = `+1${cleanNumber}`;
      // console.log('Formatted phone number:', formattedNumber);
      return formattedNumber;
    }
  
    // If the format is invalid
    throw new Error('Invalid phone number format');
  }
  
  
  
  

  async handleSubmit(event) {
    event.preventDefault();
    const email = this.emailField.value.trim();
    let phoneNumber = this.phoneField.value.trim();

    if (!this.productInfo.productId || !this.productInfo.variantId) {
      console.error('Please select a product size before submitting.');
      return;
    }

    if (!email && !phoneNumber) {
      this.showErrorMessages();
      return;
    }

    try {
      if (phoneNumber) {
        phoneNumber = this.formatPhoneNumber(phoneNumber);
      }

      const attributes = phoneNumber ? { phone_number: phoneNumber } : {};
      const response = await BIS.create(
        email || null,
        this.productInfo.variantId,
        this.productInfo.productId,
        attributes
      );

      if (response.status === 'OK') {
        this.hideErrorMessages();
        this.showSuccessMessage();
        this.hideSubscribeMessage();
        setTimeout(() => {
          this.modal.hide();
          this.hideSuccessMessage();
        }, 2000);
      } else {
        if (!response.errors?.base?.length) {
          this.hideSuccessMessage();
          this.hideSubscribeMessage();
          this.showErrorMessages();
        } else {
          this.hideErrorMessages();
          this.showSubscribeMessage();
        }
      }
    } catch (error) {
      console.error('Error:', error.message);
      this.showErrorMessages();
      this.hideSubscribeMessage();
    }
  }

  showErrorMessages() {
    if (!this.emailField.disabled) {
      this.emailFieldParent.classList.add('field--with-error');
      this.emailFieldParent.querySelector('.field__error-message').style.display = 'block';
    }
    if (!this.phoneField.disabled) {
      this.phoneFieldParent.classList.add('field--with-error');
      this.phoneFieldParent.querySelector('.field__error-message').style.display = 'block';
    }
  }

  hideErrorMessages() {
    this.emailFieldParent.classList.remove('field--with-error');
    this.emailFieldParent.querySelector('.field__error-message').style.display = 'none';
    this.phoneFieldParent.classList.remove('field--with-error');
    this.phoneFieldParent.querySelector('.field__error-message').style.display = 'none';
  }

  showSuccessMessage() {
    if (this.successMessage) {
      this.successMessage.style.display = 'block';
    }
  }

  showSubscribeMessage() {
    if (this.subscribedMessage) {
      this.subscribedMessage.style.display = 'block';
    }
  }

  hideSuccessMessage() {
    if (this.successMessage) {
      this.successMessage.style.display = 'none';
    }
  }

  hideSubscribeMessage() {
    if (this.subscribedMessage) {
      this.subscribedMessage.style.display = 'none';
    }
  }

  init() {
    this.sendButton.addEventListener('click', (event) => this.handleSubmit(event));
  }
}


// Initialize the modal dialog and form submission handler
const modal = document.querySelector('modal-dialog'); // Select your modal dialog instance
const formSubmissionHandler = new FormSubmissionHandler(
  document.querySelector('.bis-popup-send'),
  document.querySelector('#bis-email-field'),
  document.querySelector('#bis-phone-field'),
  productInfo,
  modal // Pass modal instance to the handler
);
formSubmissionHandler.init();
